export const switchTheme = value => ({
    type: 'SET_THEME',
    value
});

export const setThemeSettings = value => ({
  type: 'SET_THEME_SETTINGS',
  value
});
